import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { ThemeContext } from "../../Context/theme";
import resume from "../Images/Rahul.pdf"
import DownloadForOfflineRoundedIcon from '@mui/icons-material/DownloadForOfflineRounded';
import { Button } from "@material-ui/core";


export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);


  const handleClick = () => {
    window.location.href = "https://drive.google.com/file/d/1uOgRL4VFNUi3VP1yqUvHaAHZdH2k4B5V/view?usp=share_link"
  }

  return (
    <>
      <section id="#about" style={{ boxShadow: "rgba(1, 102, 214, 0.1) 0px 0px 0px 1px" }}>
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img
                src="https://images2.imgbox.com/0a/76/YDYcMDqk_o.jpg"
                alt="Images"
              />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                Hi Everyone, My name is{" "}
                <span className="different">Rahul Singh </span> and  I am {" "}
                <span className="different"> from Deoria,{" "}Uttar-Pradesh (India)</span>.
                I completed my Diploma in  <span className="different">Electrical Engineering</span> from Prasad Institute of Technology, Lucknow.
                Then I joined full stack development course by <span className="different">Masai School</span>  a military type coding school.
              </h4>
              <h4>Some of my interests apart form Coding :</h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Bikes Enthusiast{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Cricket Enthusiast{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Travelling{" "}
              </h4>


              <a
                href={resume}
                target="_blank"
                rel="noreferrer"
                download="fw20_1180_Rahul_Singh_Resume">

                <Button type="button" className="btn btn--outline" style={{ width: "100px", height: "40px", marginTop: "10px", marginLeft: "30px", paddingBottom: "1px", marginBottom: "10px", paddingRight: "1px", paddingLeft: "5px", borderRadius: "7px" }} onClick={handleClick}>
                  Resume <DownloadForOfflineRoundedIcon />
                </Button>

              </a>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};
